export default __webpack_public_path__ + "static/media/instagram.d37acdd3.svg";